module.exports = __webpack_public_path__ + "assets/general.e332c92a.svg";